import React, { useRef } from "react";
import SvgFiltre from "../../_svg/Filtre";
import { withTranslation } from 'react-i18next';

const App = (props) => {
  const ref = useRef();
  const { t } = props
  const content = {
    title: t('applications.filter'),
    description: t('applications.saphir.filter.description')
  }
  return (
              <div className={"svg-container"} id={"svg-filter-saphir"} itemScope itemType="https://schema.org/WebPage">
                <div>
                  <SvgFiltre fill={"#b77830"} />
                  <h3 itemProp="alternativeHeadline">{content.title}</h3>
                  <span itemProp="description">
                    {content.description}
                  </span>
                </div>
              </div>
  );
};

const tr = withTranslation()(App);
export default tr;
